export class MrsChip{
    id:string;
    label:string;
    value:string;
    selected = false;
    disabled?:boolean;
    selectable = true;
}